export default "__VITE_ASSET__OZTM8MHc__"